export { Highlighter } from './Highlighter';
export { HighlighterProps } from './Highlighter.types';
